import createSvgIcon from '../../Utils/CreateSvgIcon';

export const GradeMatrix = createSvgIcon(
  <>
    <path
      d="M27 8L13 8C11.8954 8 11 8.89543 11 10L11 22C11 23.1046 11.8954 24 13 24H27C28.1046 24 29 23.1046 29 22L29 10C29 8.89543 28.1046 8 27 8Z"
      transform="translate(-8 -4)"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9967 11.9561L21.0074 11.9844L23.942 19.8916L23.9635 19.9512L22.1041 19.9512L22.0944 19.9209L21.5133 18.2188H18.7867L18.2057 19.9209L18.1959 19.9512H16.3365L16.358 19.8916L19.2867 11.9844L19.2975 11.9561H20.9967ZM19.1783 16.8477H21.1217L20.15 13.9854L19.1783 16.8477Z"
      transform="translate(-8 -4)"
      stroke="currentColor"
      strokeWidth="0.0887724"
    />
  </>,
  'GradeMatrix',
);
